import { HStack, Switch } from "@chakra-ui/react";

import {
  SlackChannelDisplay,
  SlackChannelDisplayProps,
} from "./SlackChannelDisplay";

type SlackChannelToggleProps = SlackChannelDisplayProps & {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
};

export function SlackChannelToggle({
  enabled,
  slackChannel,
  onToggle,
  showIcon = true,
  ...stackProps
}: SlackChannelToggleProps) {
  return (
    <HStack width="full" {...stackProps}>
      <Switch
        isChecked={enabled}
        size="sm"
        onChange={(value) => {
          onToggle!(value.target.checked);
        }}
      />
      <SlackChannelDisplay showIcon={showIcon} slackChannel={slackChannel} />
    </HStack>
  );
}
